export default __webpack_public_path__ + "static/media/man-code.32d678a2.png";